import { useContext, useEffect, useState } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import casinoWorker from '../../workers/casino/casinoWorker'
import { getActiveItems } from '../../dataManipulation/cmsItems'
import { AuthContext } from '../../context/authProvider'

export const useCasinoApiData = (type) => {
  const [searchModalGames, setSearchModalGames] = useState()
  const [tabsCasinoData, setTabsCasinoData] = useState({})

  const fullData = graphql`
    {
      casinoApi {
        values {
          casinoData {
            acf_fc_layout
            lobby_type
            title
            # Exclusive to banners
            banners {
              activeTo
              activeFrom
              background_color
              header_tag
              header_text
              sub_text
              text_color
              visibility_setting
              cta_logged_out {
                action_text
                link
                background_color
                text_color
              }
              cta_logged_in {
                action_text
                link
                background_color
                text_color
              }
              background_image {
                alt
                title
                url
                sizes {
                  medium
                  medium_large
                  large
                }
              }
              background_image_mobile {
                alt
                title
                url
                sizes {
                  medium
                  medium_large
                  large
                }
              }
            }
            # Exclusive to games
            size
            category_title_tag
            logged_out_description
            visibility_setting
            game_category {
              type
              name
              slug
              is_visible
              carousel_games {
                created_at
                desktopSlug
                mobileSlug
                title
                slug
                providerName
                providerCode
                providerSlug
                exclude_by_geo_location
                mock
                disable_play_for_fun
                maintenance_mode {
                  active_to
                  active_from
                }
                thumbnail {
                  url
                  title
                  sizes {
                    medium
                    medium_large
                    large
                  }
                }
                thumbnail_tall {
                  url
                  title
                  sizes {
                    medium
                    medium_large
                    large
                  }
                }
                game_tags
              }
            }
            # Exclusive to menu
            menu_items {
              icon {
                url
                alt
              }
              title
              type
            }
            # Exclusive to providers
            providers {
              name
              id
              slug
              active
              exclude_by_geo_location
              vertical_lobby_display
              logo {
                url
                alt
              }
            }
            # Exclusive to Search
            search_modal_category_setup {
              title
              game_category {
                carousel_games {
                  created_at
                  desktopSlug
                  mobileSlug
                  title
                  slug
                  providerName
                  providerCode
                  providerSlug
                  exclude_by_geo_location
                  disable_play_for_fun
                  maintenance_mode {
                    active_to
                    active_from
                  }
                  thumbnail {
                    alt
                    title
                    sizes {
                      medium
                      medium_large
                      large
                    }
                  }
                  thumbnail_tall {
                    alt
                    title
                    sizes {
                      medium
                      medium_large
                      large
                    }
                  }
                  game_tags
                }
              }
            }
            all_providers_seo {
              logged_out_description
              logged_out_title
              seo {
                activeFrom
                activeTo
                header_title
                seo_content
              }
            }
          }
        }
      }
    }
  `
  const resFullData = useStaticQuery(fullData)
  const { accessCountry, isLoggedIn } = useContext(AuthContext)

  const casinoApi = resFullData.casinoApi?.values

  const filteredCasinoData = casinoWorker?.filterCasinoData(casinoApi, type)
  const casinoData = casinoWorker?.filterCasinoGamesProviders(
    filteredCasinoData,
    accessCountry,
    isLoggedIn
  )

  useEffect(() => {
    const getFilteredData = async () => {
      const searchModalGamesResult = casinoWorker?.filterSearchModalGames(
        casinoData,
        accessCountry,
        isLoggedIn
      )
      setSearchModalGames(searchModalGamesResult)

      const horizontalMenuDataResult =
        await casinoWorker?.filterHorizontalMenu(casinoData)
      setTabsCasinoData(horizontalMenuDataResult)
    }
    getFilteredData()
  }, [casinoApi, type])

  const getDataFromCasinoApi = () => {
    const casinoValues = resFullData?.casinoApi?.values
    const { casinoData } =
      casinoValues?.find((casinoGroup) =>
        casinoGroup?.casinoData?.some(
          ({ lobby_type }) => lobby_type == 'all_providers_seo'
        )
      ) ?? {}
    if (!casinoData || casinoData?.length <= 1) return {}
    const allProvidersSeo = casinoData[1]?.all_providers_seo
    return {
      seo: getActiveItems(allProvidersSeo.seo),
      description: allProvidersSeo.logged_out_description,
      title: allProvidersSeo.logged_out_title,
    }
  }
  const { seo, description, title } = getDataFromCasinoApi()
  return {
    casinoData,
    searchModalGames,
    tabsCasinoData,
    seo,
    description,
    title,
  }
}
